module.exports = __webpack_public_path__ + "static/nextYellow-ff2a2d9a739ec1f8c3018c66d9e14019.png";